export default {
    CAT: 1,
    RAAT: 2,
    AMBOS: 3,
}
